import SignIn from "../Authentication/SignIn";
import ProductDetail from "../Components/Products/ProductDetail";
import ProductList from "../Components/Products/ProductList";
import AccountDeletion from "../Components/UserAccount/AccountDeactivation";
import ChooseLanguage from "../Components/UserAccount/ChooseLanguage";
import MyBankAccount from "../Components/UserAccount/MyBankAccount";
import MyBillingDetails from "../Components/UserAccount/MyBillingDetails";
import MyInvoices from "../Components/UserAccount/MyInvoices";
import MyOrders from "../Components/UserAccount/MyOrders";
import TrackOrder from "../Components/UserAccount/MyOrders/TrackOrder";
import MyQuestionsAnswer from "../Components/UserAccount/MyQuestionsAnswer";
import MyReviews from "../Components/UserAccount/MyReviews";
import MyWallet from "../Components/UserAccount/MyWallet";
import MyWishList from "../Components/UserAccount/MyWishList";
import ReferAndEarn from "../Components/UserAccount/ReferAndEarn";
import Settings from "../Components/UserAccount/Settings";
import StoreLocation from "../Components/UserAccount/StoreLocation";
import StoreRewards from "../Components/UserAccount/StoreRewards";
import Catgegories from "../Pages/Categories";
import CategoryLandingPage from "../Pages/Categories/CategoryLandingPage";
import Earnings from "../Pages/Earnings";
import Home from "../Pages/Home";
import Profile from "../Pages/Profile";
import Shared from "../Pages/Shared";

export const routes = [
  {
    id: 1,
    path: "/",
    element: <Home />,
  },
  {
    id: 4,
    path: "/categories",
    element: <Catgegories />,
  },
  {
    id: 5,
    path: "/profile",
    element: <Profile />,
  },
  {
    id: 6,
    path: "/all-products",
    element: <ProductList />,
  },
  {
    id: 7,
    path: "/product/:id/:name",
    element: <ProductDetail />,
  },
  {
    id: 8,
    path: "/login",
    element: <SignIn />,
  },
  {
    id: 9,
    path: "/earnings",
    element: <Earnings />,
  },
  {
    id: 10,
    path: "/orders",
    element: <MyOrders />,
  },
  {
    id: 11,
    path: "/shared",
    element: <Shared />,
  },
  {
    id: 12,
    path: "/shared",
    element: <Shared />,
  },
  {
    id: 13,
    path: "/bank-accounts",
    element: <MyBankAccount />,
  },
  {
    id: 14,
    path: "/wishlist",
    element: <MyWishList />,
  },
  {
    id: 15,
    path: "/billing-details",
    element: <MyBillingDetails />,
  },
  {
    id: 16,
    path: "/my-reviews",
    element: <MyReviews />,
  },
  {
    id: 17,
    path: "/wallets",
    element: <MyWallet />,
  },
  {
    id: 18,
    path: "/questions-answers",
    element: <MyQuestionsAnswer />,
  },
  {
    id: 19,
    path: "/choose-language",
    element: <ChooseLanguage />,
  },
  {
    id: 20,
    path: "/store-locations",
    element: <StoreLocation />,
  },
  {
    id: 21,
    path: "/store-rewards",
    element: <StoreRewards />,
  },
  {
    id: 22,
    path: "/refer-and-earn",
    element: <ReferAndEarn />,
  },
  {
    id: 23,
    path: "/settings",
    element: <Settings />,
  },
  {
    id: 24,
    path: "/category",
    element: <CategoryLandingPage />,
  },
  {
    id: 25,
    path: "/invoices",
    element: <MyInvoices />,
  },
  {
    id: 26,
    path: "/invoices",
    element: <MyInvoices />,
  },
  {
    id: 27,
    path: "/account-deletion",
    element: <AccountDeletion />,
  },

  {
    id: 27,
    path: "/track-order",
    element: <TrackOrder />,
  },



];
